import { useDispatch } from "react-redux";
import { setCurrentUser } from "newui/features/Auth/authSlice";
import { useCurrentUser } from "hooks/auth";
import { apiV1 } from "api-v2";

/**
 * Hook returns a callback to update user tour flags
 * TODO:: Review if this is working corrcetly
 */
export const useUpdateUserTourFlags = () => {
	const { currentUser } = useCurrentUser();
	const dispatch = useDispatch();

	const updateTourFlags = async (
		uiTour: boolean,
		rfqTour: boolean
	): Promise<void> => {
		if (!currentUser) {
			return;
		}

		try {
			const result = await apiV1.post(`users/user-guide`, {
				ui_tour_seen: uiTour ? 1 : 0,
				rfq_tour_seen: rfqTour ? 1 : 0,
			});

			if (!result.data?.success) {
				throw new Error(result.data?.message || "Update failed");
			}

			console.log("Tour flags updated successfully");
			return result.data;
		} catch (error) {
			console.error("Error updating tour flags", {
				error,
				userId: currentUser.id,
				uiTour,
				rfqTour,
			});
			throw error;
		} finally {
			// Always update local user state regardless of server success
			dispatch(
				setCurrentUser({
					...currentUser,
					ui_tour_seen: uiTour,
					rfq_tour_seen: rfqTour,
				})
			);
		}
	};

	return updateTourFlags;
};
